export enum NotificationType {
    'info',
    'warning',
    'success',
    'error'
}

export interface NotificationData {
  message: string;
  type: NotificationType;
  action?: string;
}